export default __webpack_public_path__ + "static/media/3132 spice rack D top.619a6f8f.png";